import React from 'react';
import { connect } from 'react-redux';
import Header from '../elements/Header';
import NextStep from '../elements/NextStep';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { __, __n } from 'i18n-for-browser';

import ListButton from '../elements/ListButton';
import Defines from '../../Defines';
import {
  getUnreadWinstGlobas,
  getUnreadVerliesGlobas,
  unreadCount,
  getPolicyChoiceFeedback,
  getPolicyChoiceTotalPoints,
} from '../../helpers/feedbackHelpers';
import { getTotalCosts, choicesToMake } from '../../helpers/policyChoiceHelper';
import { getMinistryGlobasSpent } from '../../helpers/calculationsHelper';
import { getOverviewData } from '../../helpers/ministriesHelper';
import { dispatchUnreadPopup } from "../../helpers/popupHelper";
import DifficultyAwareComponent from "../DifficultyAwareComponent";
import {
  calculateBudgetPRO, calculateSavingsAndLoans, calculateBudgetBASIC
} from '../../helpers/calculationsHelper';

import Team from '../../assets/img/icons/economy/team.svg';
import Economy from '../../assets/img/icons/economy/economy.svg';
import UpGlobas from '../../assets/img/icons/economy/up-globas.svg';
import UpMinGlobas from '../../assets/img/icons/economy/up-min-globas.svg';
import MinGlobas from '../../assets/img/icons/economy/min-globas.svg';
import BeleidskeuzeL from '../../assets/img/icons/beleidskeuze_L.svg';
import SparenBank from '../../assets/img/icons/sparen_bank.svg';
import actions from '../../actions';
import PopUp from '../elements/PopUp';
import Warning from "../../assets/img/icons/warning.svg";
import PopupTitle from "../elements/PopupTitle";

const { submitMyState } = actions.gameStateInput;

/**
 * Import assets
 */
class Ministries extends DifficultyAwareComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      showWarning: '',
      showWarningId: '',
      showOverview: false
    };
  }

  toggleOverviewPopUp = () => {
    this.setState({
      showOverview: !this.state.showOverview,
    })
  }

  componentDidMount() {
    const { gameState, dispatch, project } = this.props;
    const currentRound = (gameState.Rounds ? gameState.Rounds.length - 1 : 1);
    if (currentRound === 1 && gameState.currentStep === 1) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtlandbesturen1_T1' : 'mlgvtlandbesturen1_T1'), dispatch);
    }
    if (currentRound === 2 && gameState.currentStep === 1) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtlandbesturen2_T1' : 'mlgvtlandbesturen2_T1'), dispatch, true);
    }
    if (currentRound === 1 && gameState.currentStep === 3) {
      dispatchUnreadPopup((project.difficulty === "PRO" ? 'mhgvtbudgetverdelen_T1' : 'mlgvtbudgetverdelen_T1'), dispatch);
    }
    if (window.scrollToMinistry) {
      const ministryElement = document.getElementById(`scrollto-${window.scrollToMinistry}`);
      if (ministryElement) {
        const y = ministryElement.getBoundingClientRect().top + window.pageYOffset;
        const yOffset = -50;
        window.scrollTo({
          top: y + yOffset,
        });
      }
    }
    window.scrollToMinistry = undefined;
  }

  allowSave = () => {
    const { gameState, gameStateInput, policyChoice } = this.props;
    if (gameState.difficulty === 'BASIC' && choicesToMake(policyChoice, gameStateInput.myState.policyChoices, this.props.project.minPolicyChoices) > 0) {
      return false;
    }
    return true;
  }

  renderLaag() {
    const { gameState, gameStateInput, feedback, policyChoice, group } = this.props;
    const { prevRoundSum } = gameState;
    const { ministerieGlobaVerdeling, ministryCollaborations, policyChoices } = gameStateInput.myState;
    const { currentRound } = gameState;
    const currentRoundGameState = gameState.Rounds[currentRound];
    const { prevRoundFeedbackData } = feedback;
    const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);
    const globas = calculateBudgetBASIC(gameState, policyChoices, ministerieGlobaVerdeling, savingsAndLoans, policyChoice);
    if (!prevRoundSum) return null;
    const { OneTimeEffect } = prevRoundSum;
    const unreadWinstGlobas = getUnreadWinstGlobas(prevRoundFeedbackData).length;
    const unreadVerliesGlobas = getUnreadVerliesGlobas(prevRoundFeedbackData).length;
    const isStartSituation = (group.Rounds.length === 2);
    const { remainingSavingsPoints, remainingProfitLossPoints } = gameState.gameStateSum;
    console.log(gameState.gameStateSum);
    return (
      <div>
        <Header match={this.props.match} history={this.props.history} historic={false} buttonType="view" viewType='list' showBudget={gameState.currentStep === 3} />
        <div className='container ministries-list'>
          {gameState.currentStep === 3 ? null : (
            <div className='economy-list'>
              <PopupTitle popupId={'mlgvteconomie'} tag={'h3'} />
              <Link to={{
                pathname: "/economy/total"
              }}>
                <ListButton className={'total-economy-list-button'} bgColor='darkblue' title={__("sim_totalglobas")} icon={Economy} globas={gameState.totalEconomy} points={currentRoundGameState.earnedPoints} />
              </Link>

              <Link to={!(currentRound === 5) ?
                {
                  pathname: "/economy/earned"
                } : {}}>
                <ListButton bgColor='blue' title={__("sim_earnedglobas")} icon={Team} globas={currentRound === 5 ? '-' : currentRoundGameState.earnedGlobas} points={currentRound === 5 ? '-' : currentRoundGameState.earnedPoints} />
              </Link>

              <Link to={{
                pathname: "/ministries/overview/profit"
              }}>
                <ListButton bgColor='blue' title={__('sim_winstglobas')} icon={UpGlobas} feedbackCount={unreadWinstGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.WG === 0 ? 0 : '+ ' + OneTimeEffect.WG)} />
              </Link>
              <Link to={{
                pathname: "/ministries/overview/loss"
              }}>
                <ListButton bgColor='blue' title={__('sim_verliesglobas')} icon={MinGlobas} feedbackCount={unreadVerliesGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.VG === 0 ? 0 : '- ' + -OneTimeEffect.VG)} />
              </Link>
            </div>
          )}

          {gameState.currentStep === 1 && gameState.currentRound <= 1 ? null : (
            this.props.project.minPolicyChoices > 0 ? (
              <div className='economy-list'>
                <PopupTitle popupId={'mlgvtstap3beleidskeuzes'} tag={'h3'} />
                <Link to="/beleidskeuzes" onClick={() => { sessionStorage.setItem('toMin', 'list') /* 🤮🤮🤮 */ }}>
                  <ListButton
                    bgColor='darkblue'
                    title={__n('sim_beleidskeuze', 0)}
                    className={"beleidskeuze-listbutton-laag"}
                    icon={BeleidskeuzeL}
                    feedbackCount={
                      gameState.currentStep === 3
                        ? choicesToMake(policyChoice, gameStateInput.myState.policyChoices, this.props.project.minPolicyChoices)
                        : unreadCount(getPolicyChoiceFeedback(feedback.prevRoundFeedbackData), null, true)
                    }
                    arrow={true}
                    redNotification={gameState.currentStep === 3}
                    points={gameState.currentStep === 1 ? getPolicyChoiceTotalPoints(feedback.prevRoundFeedbackData) : false}
                    globas={gameState.currentStep === 3 ? getTotalCosts(gameStateInput.myState.policyChoices, policyChoice) : undefined}
                  />
                </Link>
              </div>
            ) : null
          )}

          <div className='ministry-list'>
            <PopupTitle popupId={'mlgvtministeries'} tag={'h3'} />
            {Defines['basic'].ministries.map(min => (
              <Link key={min} to={`/ministries/${gameState.currentStep === 3 ? 'budget/' : ''}${min.toLowerCase()}`} onClick={() => { sessionStorage.setItem('toMin', 'list') /* 🤮🤮🤮 */ }}>
                <ListButton
                  ministry={min}
                  title={__(min)}
                  icon={Defines.icons[min]}
                  arrow={true}
                  points={gameState.currentStep === 1 ? (prevRoundSum ? prevRoundSum[`${min}_points`] + '' : '...') : false}
                  global={Defines.i18nMinistries.includes(min)}
                  globas={getMinistryGlobasSpent(ministerieGlobaVerdeling, min, gameState.currentStep)}
                  collaboration={gameState.currentStep === 1 ? ministryCollaborations[min] : ministerieGlobaVerdeling[min + 'SW']}
                />
              </Link>
            ))}
          </div>

          {remainingSavingsPoints > 0 || remainingProfitLossPoints !== 0 && !gameState.history ? (
            <div className="overige-list">
              <PopupTitle popupId={'mhgvtoverzicht_overige'} tag={'h3'} />
              {remainingSavingsPoints > 0 ?
                <ListButton
                  title={__('sim_overige_spaargeld')}
                  icon={SparenBank}
                  arrow={true}
                  points={remainingSavingsPoints}
                />
                : null}
              {remainingProfitLossPoints !== 0 ?
                <ListButton
                  title={__('sim_overige_wgvg')}
                  icon={UpMinGlobas}
                  arrow={true}
                  points={remainingProfitLossPoints}
                />
                : null}
            </div>
          ) : null}

          {this.props.gameState.roundData.state === 'SIMULATION_SPENDING' && this.props.gameStateInput.myState.SIMULATION_SPENDING !== 'PROCESSED' ? (
            <div className="buttonWrap">
              <button onClick={this.toggleOverviewPopUp} className={'button button--blue'}><span>{__('sim_overzicht_verdeling')}</span></button>
              {this.state.showOverview ?
                <PopUp
                  interactive
                  showPopUp={true}
                  closePopUpCross={true}
                  closePopUpClick={this.toggleOverviewPopUp}
                >{getOverviewData(this.props)}</PopUp>
                : null}
              {this.props.user.role === 'groupleader' ? (
                <button
                  onClick={(ev) => {
                    ev.preventDefault();
                    if (globas !== 0) {
                      this.setState({ showWarningId: 'dlgmstap3verdelingopslaan' });
                      return;
                    }
                    if (globas === 0 && !this.allowSave()) {
                      this.setState({ showWarningId: 'dlgmstap3verdelingopslaan_1' });
                      return;
                    }
                    // @todo conditional
                    if (globas === 0 && this.allowSave() && this.props.user.role === 'groupleader' && !this.props.gameStateInput.preventInputChanges) {
                      this.props.dispatch(submitMyState('SIMULATION_SPENDING'));
                    }
                  }}
                  className={`button${globas === 0 && this.allowSave() && !this.props.gameStateInput.preventInputChanges ? '' : ' disabled pointer-events'}`}
                >
                  <span>{__('sim_verdling_opslaan_button')}</span>
                </button>
              ) : null}
            </div>
          ) : null}
        </div>
        {this.state.showWarning.length ? (
          <PopUp
            img={Warning}
            popUpFooter={true}
            description={__(this.state.showWarning)}
            closePopUpClick={() => this.setState({ showWarning: '' })}
          />
        ) : null}
        {this.state.showWarningId.length ? (
          <PopUp
            img={Warning}
            popUpFooter={true}
            id={this.state.showWarningId}
            closePopUpClick={() => this.setState({ showWarningId: '' })}
          />
        ) : null}
        <NextStep />
      </div>
    );
  }

  renderHoog() {
    const { gameState, gameStateInput, feedback, group } = this.props;
    const { prevRoundSum } = gameState;
    const { ministerieGlobaVerdeling, policyChoices } = gameStateInput.myState;
    const { currentRound } = gameState;
    const currentRoundGameState = gameState.Rounds[currentRound];
    const { prevRoundFeedbackData } = feedback;
    if (!prevRoundSum) return null;
    const { OneTimeEffect } = prevRoundSum;
    const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);
    const globas = calculateBudgetPRO(gameState, gameStateInput, policyChoices, ministerieGlobaVerdeling, savingsAndLoans);
    const policyChoicesArray = Object.values(gameStateInput.myState.policyChoices);
    const isStartSituation = (group.Rounds.length === 2);

    const unreadWinstGlobas = getUnreadWinstGlobas(prevRoundFeedbackData).length;
    const unreadVerliesGlobas = getUnreadVerliesGlobas(prevRoundFeedbackData).length;
    const { remainingSavingsPoints, remainingProfitLossPoints } = gameState.gameStateSum;
    return (
      <div>
        <Header match={this.props.match} history={this.props.history} historic={false} buttonType="view" viewType='list' showBudget={gameState.currentStep === 3} />
        <div className='container ministries-list'>
          {gameState.currentStep === 3 ? null : (
            <div className='economy-list'>
              <PopupTitle popupId={'mhgvteconomie'} tag={'h3'} />
              <Link to={{
                pathname: "/economy/total"
              }}>
                <ListButton className={'total-economy-list-button'} bgColor='darkblue' title={__("sim_totalglobas")} icon={Economy} globas={gameState.totalEconomy} points={currentRoundGameState.earnedPoints} />
              </Link>
              <Link to={!(currentRound === 5) ?
                {
                  pathname: "/economy/earned"
                } : {}}>
                <ListButton bgColor='blue' title={__("sim_earnedglobas")} icon={Team} globas={currentRound === 5 ? '-' : currentRoundGameState.earnedGlobas} points={currentRound === 5 ? '-' : currentRoundGameState.earnedPoints} />
              </Link>
              <Link to={{
                pathname: "/ministries/overview/profit"
              }}>
                <ListButton bgColor='blue' title={__('sim_winstglobas')} icon={UpGlobas} feedbackCount={unreadWinstGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.WG === 0 ? 0 : '+ ' + OneTimeEffect.WG)} />
              </Link>
              <Link to={{
                pathname: "/ministries/overview/loss"
              }}>
                <ListButton bgColor='blue' title={__('sim_verliesglobas')} icon={MinGlobas} feedbackCount={unreadVerliesGlobas} globas={isStartSituation ? '-' : (OneTimeEffect.VG === 0 ? 0 : '- ' + -OneTimeEffect.VG)} />
              </Link>
            </div>
          )}
          <div className='ministry-list'>
            <PopupTitle popupId={'mhgvtministeries'} tag={'h3'} />
            {Defines['pro'].ministries.map(min => (
              <Link key={min} to={`/ministries/${gameState.currentStep === 3 ? 'budget/' : ''}${min.toLowerCase()}`}>
                <ListButton
                  ministry={min}
                  title={__(min)}
                  icon={Defines.icons[min]}
                  arrow={true}
                  stars={Defines.ministeryStars[min]}
                  globas={getMinistryGlobasSpent(ministerieGlobaVerdeling, min, gameState.currentStep, policyChoicesArray)}
                  points={gameState.currentStep === 1 ? (prevRoundSum ? prevRoundSum[`${min}_points`] + '' : 0) : false}
                  global={Defines.i18nMinistries.includes(min)}
                  budgetSet={ministerieGlobaVerdeling[min] && gameState.currentStep > 1}
                  policySet={policyChoicesArray.find(choice => choice.ministry === min && choice.selected) && gameState.currentStep > 1}
                  disaster={false}
                />
              </Link>
            ))}
          </div>
          {remainingSavingsPoints > 0 || remainingProfitLossPoints !== 0 && !gameState.history ? (
            <div className="overige-list">
              <PopupTitle popupId={'mhgvtoverzicht_overige'} tag={'h3'} />
              {remainingSavingsPoints > 0 ?
                <ListButton
                  title={__('sim_overige_spaargeld')}
                  icon={SparenBank}
                  arrow={true}
                  points={remainingSavingsPoints}
                />
                : null}
              {remainingProfitLossPoints !== 0 ?
                <ListButton
                  title={__('sim_overige_wgvg')}
                  icon={UpMinGlobas}
                  arrow={true}
                  points={remainingProfitLossPoints}
                />
                : null}
            </div>
          ) : null}
          {this.props.gameState.roundData.state === 'SIMULATION_SPENDING' && this.props.gameStateInput.myState.SIMULATION_SPENDING !== 'PROCESSED' ? (
            <div className="buttonWrap">
              <button onClick={this.toggleOverviewPopUp} className={'button button--blue'}><span>{__('sim_overzicht_verdeling')}</span></button>
              {this.state.showOverview ?
                <PopUp
                  interactive
                  showPopUp={true}
                  closePopUpCross={true}
                  closePopUpClick={this.toggleOverviewPopUp}
                >{getOverviewData(this.props)}</PopUp>
                : null}
              {this.props.user.role === 'groupleader' ? (
                <button
                  onClick={(ev) => {
                    ev.preventDefault();
                    if (globas !== 0) {
                      this.setState({ showWarningId: 'mhgmstap3verdelingopslaan' });
                      return;
                    }
                    // @todo conditional
                    if (globas === 0 && !this.props.gameStateInput.preventInputChanges) {
                      this.props.dispatch(submitMyState('SIMULATION_SPENDING'));
                    }
                  }}
                  className={`button${globas === 0 && !this.props.gameStateInput.preventInputChanges ? '' : ' disabled pointer-events'}`}
                >
                  <span>{__('sim_verdling_opslaan_button')}</span>
                </button>
              ) : null}
            </div>
          ) : null}
        </div>
        {this.state.showWarning.length ? (
          <PopUp
            img={Warning}
            popUpFooter={true}
            description={__(this.state.showWarning)}
            closePopUpClick={() => this.setState({ showWarning: '' })}
          />
        ) : null}
        {this.state.showWarningId.length ? (
          <PopUp
            img={Warning}
            popUpFooter={true}
            id={this.state.showWarningId}
            closePopUpClick={() => this.setState({ showWarningId: '' })}
          />
        ) : null}
        <NextStep />
      </div>
    );
  }
}

export default connect(state => state)(Ministries);



// WEBPACK FOOTER //
// ./src/components/routes/Ministries.js